import { render } from "./App.vue?vue&type=template&id=c8696dde"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c8696dde&lang=scss"

import exportComponent from "/Users/dongyucheng/小飞蛾/哈尔滨超付商务信息咨询服务有限公司/code/lxk_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__